import { Plugins } from '@leverege/plugin';
import RsrcTable from "./rsrcTable/RsrcTable.js";
import RsrcTree from "./rsrcTree/RsrcTree.js";
import RsrcList from "./rsrcList/RsrcList.js";
import DetailRenderers from './detailRenderer/PluginSetup.js';
import Search from './search/PluginSetup.js';
import Gallery from './rsrcGallery/PluginSetup.js';
import SimpleImageThumbnail from "./SimpleImageThumbnail.js";
import SimpleImageDetail from "./SimpleImageDetail.js";
import SimpleImageThumbnailModel from './SimpleImageThumbnailModel.js';
import SimpleImageDetailModel from './SimpleImageDetailModel.js';
import OverlayDetailRendererModel from './OverlayDetailRendererModel.js';
import OverlayThumbnailRendererModel from './OverlayThumbnailRendererModel.js';
import OverlayThumbnailRenderer from "./OverlayThumbnailRenderer.js";
import OverlayDetailRenderer from "./OverlayDetailRenderer.js";
function install(plg = Plugins) {
  plg.addPlugin('RsrcListRenderer', RsrcTable.PLUGIN);
  plg.addPlugin('RsrcListRenderer', RsrcTree.PLUGIN);
  plg.addPlugin('RsrcListRenderer', RsrcList.PLUGIN);
  plg.addPlugin('RsrcThumbnailRenderer', {
    type: SimpleImageThumbnailModel.TYPE,
    component: SimpleImageThumbnail
  });
  plg.addPlugin('RsrcDetailRenderer', {
    type: SimpleImageDetailModel.TYPE,
    component: SimpleImageDetail
  });
  plg.addPlugin('RsrcThumbnailRendererModel', SimpleImageThumbnailModel);
  plg.addPlugin('Model', {
    type: SimpleImageThumbnailModel.TYPE,
    model: SimpleImageThumbnailModel
  });
  plg.addPlugin('RsrcDetailRendererModel', SimpleImageDetailModel);
  plg.addPlugin('Model', {
    type: SimpleImageDetailModel.TYPE,
    model: SimpleImageDetailModel
  });
  plg.addPlugin('RsrcDetailRenderer', {
    type: OverlayDetailRendererModel.TYPE,
    component: OverlayDetailRenderer
  });
  plg.addPlugin('RsrcThumbnailRenderer', {
    type: OverlayThumbnailRendererModel.TYPE,
    component: OverlayThumbnailRenderer
  });
  plg.addPlugin('RsrcThumbnailRendererModel', OverlayThumbnailRendererModel);
  plg.addPlugin('Model', {
    type: OverlayThumbnailRendererModel.TYPE,
    model: OverlayThumbnailRendererModel
  });
  plg.addPlugin('RsrcDetailRendererModel', OverlayDetailRendererModel);
  plg.addPlugin('Model', {
    type: OverlayDetailRendererModel.TYPE,
    model: OverlayDetailRendererModel
  });
  DetailRenderers.install(plg);
  Search.install(plg);
  Gallery.install(plg);
}
export default {
  install
};